/**
 * ContractorAuditTab — F12.M Etap D Part 2 (cienki wrapper na SystemModuleAuditTab).
 *
 * Po refactor F12.M wszystkie 5 encji systemowych używa generycznego komponentu
 * `SystemModuleAuditTab` z backendem `/api/system-modules/:slug/records/:id/audit`.
 *
 * Wrapper utrzymany dla:
 *  - backward-compat istniejącego importu w ContractorDetail
 *  - zachowania `data-testid="contractor-audit-*"` w istniejących testach
 *
 * Historia: F11 T11.10 stworzyło dedykowany komponent + endpoint
 * `/api/contractors/:id/audit`. Generic endpoint zastępuje to całkowicie.
 * Stary endpoint zostaje na razie do uznania (deferred sweep — F12.M Etap E).
 */

import { SystemModuleAuditTab } from '@/components/system-modules/SystemModuleAuditTab';

interface Props {
  contractorId: string;
}

export function ContractorAuditTab({ contractorId }: Props) {
  return (
    <SystemModuleAuditTab
      moduleSlug="contractors"
      recordId={contractorId}
      testIdPrefix="contractor-audit"
    />
  );
}
